import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import bgCommon from './locales/bg/common';
import bgHome from './locales/bg/home';
import bgParticipants from './locales/bg/participants';
import bgRegistration from './locales/bg/registration';
import bgResults from './locales/bg/results';
import enCommon from './locales/en/common';
import enHome from './locales/en/home';
import enParticipants from './locales/en/participants';
import enRegistration from './locales/en/registration';
import enResults from './locales/en/results';

export const SUPPORTED_LANGUAGES = ['bg', 'en'] as const;
export type SupportedLanguage = typeof SUPPORTED_LANGUAGES[number];

const LANGUAGE_STORAGE_KEY = 'osogovo_language';

const getInitialLanguage = (): SupportedLanguage => {
    if (typeof window === 'undefined') {
        return 'bg';
    }

    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);
    if (storedLanguage === 'bg' || storedLanguage === 'en') {
        return storedLanguage;
    }

    const browserLanguage = window.navigator.language.toLowerCase();
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (browserLanguage.startsWith('bg') || timeZone === 'Europe/Sofia') {
    return 'bg';
    }

    return 'en';
};

i18n
    .use(initReactI18next)
    .init({
        resources: {
            bg: {
                common: bgCommon,
                home: bgHome,
                participants: bgParticipants,
                registration: bgRegistration,
                results: bgResults,
            },
            en: {
                common: enCommon,
                home: enHome,
                participants: enParticipants,
                registration: enRegistration,
                results: enResults,
            },
        },
        lng: getInitialLanguage(),
        fallbackLng: 'bg',
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
    });

i18n.on('languageChanged', (language) => {
    if (typeof window !== 'undefined' && (language === 'bg' || language === 'en')) {
        window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
});

export default i18n;
